import { render, staticRenderFns } from "./instruction.vue?vue&type=template&id=330c3537&scoped=true&"
import script from "./instruction.vue?vue&type=script&lang=js&"
export * from "./instruction.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=330c3537&scoped=true&lang=css&"
import style1 from "./instruction.vue?vue&type=style&index=1&id=330c3537&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330c3537",
  null
  
)

export default component.exports